const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/setupDefs.ts';
import { MessageDescriptor } from '@formatjs/intl';
import { FunctionComponent } from 'react';
import { KeyStringValuePair } from '@cistec/common_web/defs/generalDefs';

type TitleAndText = { title: MessageDescriptor; text: MessageDescriptor };

type DeadlineConfiguration = {
    dayDifference: number;
    excludeWeekend?: boolean;
    time: {
        hour: number;
        minute: number;
    };
};

export type LanguageCode = 'de' | 'fr' | 'en' | 'it';

export const languageMap: { [key in LanguageCode]: string } = {
    de: 'Deutsch',
    fr: 'Français',
    en: 'English',
    it: 'Italiano',
};

export type HttpPrefix = `https://${string}` | `http://${string}`;

export type PatAppConfiguration = {
    languages: LanguageCode[];
    footer: FunctionComponent;
    eCheckin: {
        initialValuesHook: (fallNr?: string) => any;
        form: FunctionComponent | undefined;
    };
    navbarTitle: MessageDescriptor | undefined;
    welcomeTitle: MessageDescriptor | undefined;
    welcomeText: MessageDescriptor | undefined;
    synedraCardTitle: MessageDescriptor | undefined;
    urls: {
        website: HttpPrefix;
        loginHelp: HttpPrefix | undefined;
    };
    // returns all external links
    customMetaKatMultipleKeys: KeyStringValuePair | undefined;
    // return matomo ClientID
    customMatomoClientId: number | undefined;
    bookAppointmentInfo: MessageDescriptor | undefined | null;
    bookAppointmentSlotOffset: {
        amount: number;
        unit: 'hours' | 'days';
    };
    surgeryCardHint: TitleAndText | undefined;
    SurgeryCardContactAlert: TitleAndText | undefined;
    surgeryAppointmentDeadline: DeadlineConfiguration | undefined;
    videoCallDisclaimerText: MessageDescriptor | undefined;
    aiaiBotApiKey: string | undefined;
};
